<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
                align="center"
                justify="center"
            >
                <h1>Manage User</h1>
            </v-col>
        </v-row>
        <UserEditForm mode="edit" />
    </v-container>
</template>

<script>
import UserEditForm from './Components/UserEditForm';
export default {
    components: { UserEditForm },

    props: ['mode'],
};
</script>
